import { render, staticRenderFns } from "./zhuanhuoTZ.vue?vue&type=template&id=0257183b&scoped=true&"
import script from "./zhuanhuoTZ.vue?vue&type=script&lang=js&"
export * from "./zhuanhuoTZ.vue?vue&type=script&lang=js&"
import style0 from "./zhuanhuoTZ.vue?vue&type=style&index=0&id=0257183b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0257183b",
  null
  
)

export default component.exports